export default "__VITE_ASSET__D$QZsm7U__"